import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { AuthService, ENVIRONMENT, UserService } from '@cfp/core';
import { ChangePasswordForm } from '@cfp/shared/auth';
import { LoginCard } from '@cfp/shared/ui/login';
import { ButtonLoading, Link } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { UserResponseDTO } from 'csr-login-app';

@Component({
  selector: 'cfp-change-password-page',
  templateUrl: './change-password-page.html',
  imports: [ChangePasswordForm, ButtonLoading, LoginCard, TranslateModule, RouterLink, Link],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordPage implements OnInit {
  private readonly environment = inject(ENVIRONMENT);
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  protected loginRoute = this.environment.loginRoute;
  protected readonly isSaving = signal<boolean>(false);

  public ngOnInit(): void {
    this.userService.get(true).subscribe((user: UserResponseDTO) => {
      let hasParamChangePassword: boolean = false;
      this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
        hasParamChangePassword = queryParams?.changePassword;
      });

      if (!user && !this.userService.changePasswordUserName && !hasParamChangePassword) {
        this.router.navigateByUrl(this.environment.defaultRoute);
      }
    });
  }

  protected formSubmitSuccess(): void {
    this.authService.goToApp();
  }
}
